import { axiosInstance } from '../config';
import { getUserSession, getHeaders } from '../authentication';

export const getAllRoles = () => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('roles/list',config);
};
